import React from 'react';
// import CustomImage from '../../components/custom-image';
import CustomImage from '../../../components/custom-image';
import ChildEducationImage1 from '../childEducation/image1';
import ChildEducationImage2 from '../childEducation/image2';
import ChildEducationImage3 from '../childEducation/image3';
import ContentSlider from '../../../components/content-slider';

const ChildEducation = () => {
  const slider = {
    slides: [
      <div className="child-education-slider">
        <CustomImage
          className="custom-image"
          imageName="childeducation-nandghar.jpg"
          alt="Child Education"
          maxWidth="768"
        />
      </div>,
      <div className="child-education-slider">
        <CustomImage
          className="custom-image"
          imageName="childeducation-nandghar1.jpg"
          alt="Child Education"
          maxWidth="768"
        />
      </div>,
      <div className="child-education-slider">
        <CustomImage
          className="custom-image"
          imageName="childeducation-nandghar2.jpg"
          alt="Child Education"
          maxWidth="768"
        />
      </div>
    ],
  };
  
  return (
    <div className="accordion-body">
      <div className="sd-content">
          <div className="left">
            <div className="blue-box">
              <p className="feature-title"><strong>Key Features</strong></p>
              <div className="sd-column">
                <div className="left">
                  <p className="feature-subtitle">More than</p>
                  <p className="bold-text blue-text">50</p>
                  <p className="feature-benifit">initiatives across our Group companies</p>
                </div>
                <div className="right">
                  <p className="feature-subtitle">Nearly</p>
                  <p className="bold-text blue-text">300,000</p>
                  <p className="feature-benifit">children beneﬁt from these programmes</p>
                </div>
              </div>
              
            </div>
            <div className="bottom-content">
              <p><strong>Types of Interventions</strong></p>
              <p>
              Anganwadis and child-care centres; Public school infrastructure support (including sanitation); Scholarships and Teacher training; Digital classrooms & Computer-aided learning centres; Libraries; Vedantarun Schools; Exam preparation counselling; Career counselling Science Fairs
              </p>
            </div>
          </div>
          <div className="right">
            <ContentSlider
              data={slider.slides}
              customClass="blue-dots-slider"
              slidesToShow={1}
              slidesToScroll={1}
              dots={true}
            />
          </div>
      </div>
    </div>

  );
};

export default ChildEducation;
